import { ModuleType } from '../../types/modules';
import { AppState } from '../../types/store';
import { getModuleDataByModuleType } from './modules';
import { getDeviationById } from '@wix/da-shared-react/pkg/redux/deviations/selectors';

export const getSelectedTierContentType = (state: AppState) =>
  state.subscriptionsSection.tierContentType;

export const getSelectedTierEntityId = (state: AppState) =>
  state.subscriptionsSection.selectedTierEntityId;

export const getSelectedTier = (state: AppState) => {
  const selectedTierEntityId = getSelectedTierEntityId(state);
  if (!selectedTierEntityId) {
    return undefined;
  }
  return getDeviationById(state, selectedTierEntityId);
};

export const getSelectedOrFirstTier = (state: AppState) => {
  let tierEntityId = getSelectedTierEntityId(state);
  if (!tierEntityId) {
    tierEntityId = getModuleDataByModuleType(state, ModuleType.TIERS)?.tiers[0];
  }
  return tierEntityId ? getDeviationById(state, tierEntityId) : undefined;
};
